<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",

  components: {},

  created() {},
  data: () => ({
    //
  }),

  methods: {}
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Rubik&display=swap");
*,
body {
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: normal;
}
</style>
